module.exports = __webpack_public_path__ + "static/media/Smaragdenia_Filaki_7.84aed740.jpg";